export default {
  needs_work: '#9E1417',
  needs_review: '#9E9A14',
  permanent: '#0E4270',
  resolved: '#109E9A'
}



// WEBPACK FOOTER //
// ./src/helpers/pin-status-colors.js